import { addURLParameter } from '@common/utils/urlutils';
import ErrorBox from '@components/common/ErrorBox';
import Loading from '@ui/loading/Loading';
import api from '@utils/api';
import paymentutils from '@utils/paymentutils';
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
const ExpressPaymentsButtonGooglepay = (props, ref) => {
    const [error, setError] = useState();
    const [loading, setLoading] = useState();
    const [enabled, setEnabled] = useState();
    const submitPaymentRef = useRef();
    const paymentReady = (state) => {
        setLoading(true);
        api.getForm('billing', {}).then((formdef) => {
            let form = {
                adyenStateData: JSON.stringify(state.data),
                paymentMethod: 'AdyenComponent',
                adyenPaymentMethod: 'paywithgoogle',
                brandCode: 'paywithgoogle',
            };
            api.expressSubmitPayment(form, formdef).then((data) => {
                if (data.error) {
                    setLoading(false);
                    setError(JSON.stringify(data));
                }
                else {
                    api.checkoutPlaceOrder().then((data) => {
                        if (data.error) {
                            setLoading(false);
                            if (data.errorMessage) {
                                setError(data.errorMessage);
                            }
                        }
                        if (data.continueUrl && data.orderID) {
                            let newUrl = addURLParameter(data.continueUrl, 'ID', data.orderID);
                            location.href = addURLParameter(newUrl, 'token', data.orderToken);
                        }
                        else {
                            data.continueUrl;
                        }
                    });
                }
            });
        });
    };
    useEffect(() => {
        if (props.paymentMethods) {
            setEnabled(!!props.paymentMethods.AdyenPaymentMethods.paymentMethods.find((p) => p.type == 'paywithgoogle'));
        }
    }, [props.paymentMethods]);
    useEffect(() => {
        setError('');
    }, [props.bag]);
    const payWithGooglePay = () => {
        paymentutils.getAdyenCheckout(props.adyenConfig, props.bag, props.paymentMethods.AdyenPaymentMethods, true, window.formSetValue).then((resolve) => {
            let paymentcomponent = resolve.create('paywithgoogle', {
                onSubmit: (state) => {
                    console.log('google onsubmit ' + JSON.stringify(state, null, 2));
                    paymentReady(state);
                },
                onChange: (state, component) => {
                    state.isValid; // True or false. Specifies if all the information that the shopper provided is valid.
                    state.data; // Provides the data that you need to pass in the `/payments` call.
                    // console.info('handleonchange state=', JSON.stringify(state, null, 2), '\n', 'component ' + component);
                    if (state.isValid) {
                        console.log('google ondatachange ready');
                        paymentReady(state);
                    }
                },
            });
            // save the function to be called from parent
            submitPaymentRef.current = paymentcomponent.submit;
        });
    };
    useEffect(() => {
        if (props.isSelected) {
            payWithGooglePay();
        }
    }, [props.isSelected]);
    useImperativeHandle(ref, () => ({
        placeOrderWithGoogle: submitPaymentRef.current,
    }));
    // OE-24851 workaround to use both arrow with different behaviors
    const hideArrowAfterClick = () => {
        const paymentDiv = document.querySelector('.minibag__expresspayment__intro');
        if (paymentDiv) {
            paymentDiv.classList.remove('button--arrow-left');
        }
    };
    const triggerPayment = (e) => {
        var _a, _b, _c;
        e.preventDefault();
        hideArrowAfterClick();
        if ((_b = (_a = props.bag) === null || _a === void 0 ? void 0 : _a.valid) === null || _b === void 0 ? void 0 : _b.error) {
            setError((_c = props.bag.valid) === null || _c === void 0 ? void 0 : _c.message);
        }
        else {
            props.onPaymentSelected();
            props.showFlagsCallback();
        }
    };
    if (!enabled) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", Object.assign({ type: "button", className: "button button--secondary button--googlepay", "aria-pressed": props.isSelected }, (props.isSelected ? { style: { pointerEvents: 'none' }, tabIndex: -1 } : {}), { onClick: (e) => triggerPayment(e) }),
            React.createElement("span", { className: "visually-hidden" }, "Google Pay")),
        error && React.createElement(ErrorBox, { errors: [error] }),
        loading && React.createElement(Loading, null)));
};
export default forwardRef(ExpressPaymentsButtonGooglepay);
